module.exports = __webpack_public_path__ + "img/服装定制.1ed0ffca.png";